import React, { useState } from "react";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { setBooking, setExcess, setStep } from "../../../Reducer/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";

const Other = (props) => {
    const dispatch = useDispatch()
    const booking = useSelector(state => state?.booking?.booking)
    const [loading, setLoading] = useState(false)
    const setSteps = () => {
        dispatch(setStep(2))
    }
    const handleNext = async () => {
        if ((((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point) === 0.5 ? 150 : 0)) - (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) < 0) > 0 && !(Number(booking?.excess?.kmCharges || 0))) {
            toast.error("Excess KM Charges is required")
        } else if ((Number(booking?.fuel?.end || 0) - Number(booking?.fuel?.start || 0)) < 0 && !(Number(booking?.excess?.fuelCharges))) {
            toast.error("Excess Fuel Charges is required")
        } else if (Number(booking?.excess?.timeUsed || 0) > 0 && !Number(booking?.excess?.timeCharges || 0)) {
            toast.error("Excess Hour Charges is required")
        } else if (!booking?.remarks) {
            toast.error("Remarks is required");
        } else {
            let dataToBeSent = {
                excess: booking?.excess,
                remarks: booking?.remarks,
                excessCharges: booking?.excessCharges?.length ? booking?.excessCharges?.filter(element => element?.amount) : []
            }
            setLoading(true)
            const response = await Handler({ method: 'patch', data: dataToBeSent, url: `/booking/pending/second/update/${props?.bookingId}` })
            setLoading(false)
            if (response?.success) {
                dispatch(setStep(4))
            } else {
                toast.error(response?.message);
            }
        }

    }
    const handleExcess = (e) => {
        dispatch(setExcess({ [e.target.name]: e.target.value }))
    }
    const handleExcessCharges = (e, type, name) => {
        const value = Array.isArray(booking?.excessCharges) ? booking.excessCharges.filter((element) => element?.name !== type) : [];
        const already = Array.isArray(booking?.excessCharges) ? booking.excessCharges.find((element) => element?.name === type) : null;
        const updatedEntry = { ...(already || {}), name: type, [name]: e.target.value, };
        const updatedValue = [...value, updatedEntry];
        dispatch(setBooking({ excessCharges: updatedValue }));
    };
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="kmDriven" className="form-label"> Excess KM Driven </label>
                        <input name="kmDriven" id="kmDriven" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.excess?.kmDriven || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="kmCharges" className="form-label"> Excess KM Charges </label>
                        <input readOnly name="kmCharges" id="kmCharges" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.excess?.kmCharges || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="fuelConsumed" className="form-label"> Excess Fuel Consumed </label>
                        <input name="fuelConsumed" id="fuelConsumed" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.excess?.fuelConsumed || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="fuelCharges" className="form-label"> Excess Fuel Charges </label>
                        <input name="fuelCharges" id="fuelCharges" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleExcess(e) } }} autoComplete="off" disabled={loading || ((Number(booking?.fuel?.end) - Number(booking?.fuel?.start)) < 0 ? false : true)} className="form-control input-theme text-uppercase" value={booking?.excess?.fuelCharges || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="timeUsed" className="form-label"> Excess Hour Used </label>
                        <input name="timeUsed" id="timeUsed" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleExcess(e) } }} value={booking?.excess?.timeUsed || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="timeCharges" className="form-label"> Excess Hour Charges </label>
                        <input name="timeCharges" id="timeCharges" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleExcess(e) } }} value={booking?.excess?.timeCharges || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="damageCharges" className="form-label"> Excess Charges Collected </label>
                        <input name="damageCharges" id="damageCharges" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => { if (e.target.value == Number(e.target.value)) { handleExcessCharges(e, "damage", "amount") } }} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount : "") : ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="damageRemarks" className="form-label"> Excess Charges Remarks </label>
                        <input name="damageRemarks" id="damageRemarks" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => handleExcessCharges(e, "damage", "remarks")} value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.remarks : "") : ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="remarks" className="form-label"> Remarks </label>
                        <input name="remarks" id="remarks" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" onChange={(e) => dispatch(setBooking({ remarks: e.target.value }))} value={booking?.remarks || ""} />
                    </div>
                </div>
            </div>
            <NextPrev step={3} setStep={setSteps} last={4} onClick={handleNext} loading={false} />
        </React.Fragment>
    )
}

export default Other;